import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { supportingDocumentService } from '../services';
import { invoiceKeys } from './useInvoices';

export const supportingDocumentKeys = {
  all: ['supportingDocuments'] as const,
  lists: () => [...supportingDocumentKeys.all, 'list'] as const,
  list: (invoiceId: string) => [...supportingDocumentKeys.lists(), invoiceId] as const,
};

export const useSupportingDocuments = (invoiceId: string) => {
  return useQuery({
    queryKey: supportingDocumentKeys.list(invoiceId),
    queryFn: () => supportingDocumentService.getAll(invoiceId),
    enabled: !!invoiceId,
  });
};

interface UploadDocumentParams {
  invoiceId: string;
  file: File;
  description?: string;
}

interface DeleteDocumentParams {
  invoiceId: string;
  documentId: string;
}

export const useUploadSupportingDocument = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ invoiceId, file, description }: UploadDocumentParams) =>
      supportingDocumentService.upload(invoiceId, file, description),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: supportingDocumentKeys.list(variables.invoiceId),
      });
      queryClient.invalidateQueries({
        queryKey: invoiceKeys.detail(variables.invoiceId),
      });
    },
  });
};

export const useDeleteSupportingDocument = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ invoiceId, documentId }: DeleteDocumentParams) =>
      supportingDocumentService.delete(invoiceId, documentId),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: supportingDocumentKeys.list(variables.invoiceId),
      });
      queryClient.invalidateQueries({
        queryKey: invoiceKeys.detail(variables.invoiceId),
      });
    },
  });
};
